import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[href]',
})
export class HrefDirective {

  constructor(el: ElementRef) {
  }

  @HostListener('click', ['$event']) onClick(event: any) {

    let hrefValue = '';
    let baseUriValue = '';
    if (event.target.href === undefined || event.target.href === null || event.target.href instanceof Object) {
      // event.preventDefault();
      // return false;
      if (event.currentTarget.href === undefined || event.currentTarget.href === null || event.currentTarget.href instanceof Object) {
        // event.preventDefault();
        // return false;
      } else {
        hrefValue = event.currentTarget.href;
        baseUriValue = event.currentTarget.baseURI;
      }
    } else {
      hrefValue = event.target.href;
      baseUriValue = event.target.baseURI;
    }
    if (hrefValue === undefined || hrefValue === null || hrefValue === '') {
      event.preventDefault();
      return false;
    }
    const href = hrefValue.replace(baseUriValue, '');
    if (href == null || href.length === 0) {
      event.preventDefault();
      return false;
    } else if (href.indexOf('#') !== -1 && href.length === 1) {
      event.preventDefault();
      return false;
    }
    return true;
  }

}
